import styled from "styled-components";

const SrOnly = styled.h1`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`;

const PageHeading = ({ children }) => <SrOnly>{children}</SrOnly>;

export default PageHeading;
